<template>
  <div class="front">
    <router-link class="front__link" :to="nextPageRouterArray">
      <div class="front__bg">
        <div v-if="coverImagePortrait" class="front__bg-image front__bg-image--portrait" v-bind:style="{ backgroundImage: 'url(' + coverImagePortrait + ')' }"></div>
        <div class="front__bg-image" v-bind:style="{ backgroundImage: 'url(' + coverImage + ')' }"></div>
        <video class="front__bg-video" v-if="coverVideo" :src="coverVideo" muted autoplay plays-inline width="16" height="9"></video>
      </div>
      <div class="front__box">
        <h1 class="front__title" v-html="title"></h1>
        <p class="front__subtitle" v-html="subtitle"></p>
      </div>
      <div class="front__logo-wrapper">
        <img class="front__logo" src="static/svg/logo-white.svg">
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'front',
  computed: {
    ...mapGetters(['page', 'nextPageRouterArray']),
    title() {
      return this.page.title;
    },
    subtitle() {
      return this.page.subtitle;
    },
    coverImage() {
      return this.page.coverImage;
    },
    coverImagePortrait() {
      return this.page.coverImagePortrait;
    },
    coverVideo() {
      return this.page.coverVideo;
    },
  },
  mounted() {
    const bgVid = document.querySelector('.front__bg-video');
    if (bgVid) {
      bgVid.addEventListener('ended', () => {
        bgVid.classList.add('hide');
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.front {
  @include page;

  min-height: 100%;

  &__link {
    text-decoration: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
  }

  &__bg {
    flex-grow: 1;
    margin: 0;
    display: block;
    position: relative;
    overflow: hidden;


    @include not-mobile {
      margin: 0;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    @include landscape {
      margin: 20px 0 20px 20px;
      position: relative;
      top: auto;
      left: auto;
      right: auto;
      bottom: auto;
    }
  }

  &__bg-image {
    background-size: cover;
    background-position: center bottom;
    background-repeat: no-repeat;
    margin: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    @include not-mobile {
      background-position: center;
    }

    @include landscape {
      background-position: center;
    }

    &--portrait {
      display: none;
    }

    @include portrait {
      &--portrait {
        display: block;
      }

      &--portrait + & {
        display: none;
      }
    }
  }

  &__bg-video {
    min-width: 100%; 
    min-height: 100%; 
    
    /* Setting width & height to auto prevents the browser from stretching or squishing the video */
    width: auto;
    height: auto;
    
    /* Center the video */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    transition: opacity .5s;

    &.hide {
      opacity: 0;
      pointer-events: none;
    }
  }

  &__box {
    color: $c_white;
    text-decoration: none;
    margin: 0;
    background: $c_primary;
    box-sizing: border-box;
    z-index: 1;
    box-sizing: border-box;
    padding: 45px 40px;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      min-height: 250px;
      height: 100%;
      z-index: -1;
      background-position: center bottom;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('../../../static/svg/frontcover_bg-mobile.svg');
      opacity: .9;

      @include not-mobile {
        height: auto;
        min-height: auto;
        top: auto;
        bottom: 0;
        max-width: 533px;
        background-position: left bottom;
        background-image: url('../../../static/svg/frontcover_bg.svg');
        width: 533px;
        height: 407px;
      }
    }


    @include not-mobile {
      padding: 45px;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 1;
      margin: 0;
      background: none;
      overflow: visible;
      max-width: 430px;
    }

    @include landscape {
      margin: 20px 20px 20px 0;
      width: 50%;
      position: relative;
      top: auto;
      right: auto;
    }

    // @include not-tablet {
    //   width: 50%;
    // }

    // @include desktop {
    //   width: 42%;
    // }
  }

  &__title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.066;
    font-style: oblique;
    // max-width: 300px;
    padding-bottom: 8%;


    @include not-mobile {
      font-size: 35px;
      // padding-bottom: 26%;
      line-height: 1;
      margin-bottom: 20px;
      padding-bottom: 0;
    }

    @include landscape {
      padding-bottom: 5%;
      line-height: 1.066;

      @media (max-device-height: 350px) {
        font-size: 26px;
      }
    }
  }

  &__subtitle {
    margin: 0;
    font-size: 12px;
    line-height: 1.15;
    font-weight: 300;
    display: inline-block;

    @include not-mobile {
      font-size: 14px;
      line-height: 18px;
    }

    @include landscape {
      width: auto;

      @media (max-device-height: 350px) {
        font-size: 12px;
      }
    }
  }

  

  &__logo-wrapper {
    display: block;
    background: rgba($c_primary, .9);
    padding: 19px;
    position: absolute;
    top: 35px;
    right: 35px;

    @include not-mobile {
      padding: 25px;
      top: 45px;
      right: 45px;
    }
  }

  &__logo {
    width: 80px;
    display: block;

    @include not-mobile {
      width: 102px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Front.vue